import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import { $POST, $post } from "./../func";
import Switch from "@material-ui/core/Switch";
import Snackbar from "@material-ui/core/Snackbar";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FloatingLabelInput from "./FloatingLabelInput";
import Fab from "@material-ui/core/Fab";
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import Select from "react-select";

import ImageUploader from "react-images-upload";
import LinearProgress from "@material-ui/core/LinearProgress";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { make_cols } from "./MakeColumns";

const styles = (theme) => ({
    mintaraz: {
        display: "flex",
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    maxtaraz: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "flex",
        },
    },
    btnsearch: {
        cursor: "pointer",
        [theme.breakpoints.up("md")]: {
            width: "120px",
            height: "40px",
            fontSize: "15px",
        },
        width: "80px",
        height: "30px",
        fontSize: "13px",
        color: "white",
        backgroundColor: "#41589f",
        //  marginRight:'200px',
        //  marginLeft:'200px',
        marginTop: "30px",
        marginBottom: "10px",
        borderRadius: "4px",
        border: "1px solid #41589f",
    },
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
});

class ChangeWalletBalance extends Component {
    cookies = new Cookies();
    temp333;
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            requestinfofilter: [],
            rowsPerPage: 10,
            page: 0,

            WalletUser: null,
            orderBy: "user_wallet_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newFinancialDoc: true,
            search: false,
            WalletUserMaxDate: "",
            WalletUserMinDate: "",
            Amount: "",
            WalletUserMinAmount: "",
            user_wallet_amount: "",
            cntPay: "",
            sumPay: "",
            file: {},
            arrayPay: [],
            documentcount: 0,
            sumtaraz: 0,
            selectedWalletMode: null,
            description: '',   // 👈 توضیحات
            optionWalletMode: [
                { value: "add", label: "واریز" },
                { value: "get", label: "برداشت" },
            ],
        };
    }

    handleChangeDescription = (e) => {
        // اگر event اومده، مقدار واقعی رو بگیر
        const value = e.target ? e.target.value : e;
        this.setState({ description: value });
    };


    setSelectedDayMax = (event) => {
        this.setState({ WalletUserMaxDate: event }, () => {});
    };

    clearDeyMax = (event) => {
        this.setState({ WalletUserMaxDate: "" }, () => {});
    };

    setSelectedDayMin = (event) => {
        this.setState({ WalletUserMinDate: event }, () => {});
    };

    clearDeyMin = (event) => {
        this.setState({ WalletUserMinDate: "" }, () => {});
    };

    handleChangeFinancialDocCode = (event) => {
        this.setState({ user_wallet_amount: event.target.value });
    };

    handleChangeAmount = (event) => {
        this.setState({ Amount: event }, () => {});
    };

    handleChangeMinAmount = (event) => {
        this.setState({ WalletUserMinAmount: event }, () => {});
    };

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false });
    };

    handleSelectRows = (row2) => {
        this.setState(
            {
                WalletUser: row2,
                newFinancialDoc: false,
                user_wallet_amount: row2.user_wallet_amount,
            },
            () => {}
        );
    };

    newFinancialDoc = (event) => {
        this.setState({
            WalletUser: null,
            newFinancialDoc: true,
            WalletUserMaxDate: "",
            WalletUserMinDate: "",
            user_wallet_amount: "",
            Amount: "",
            WalletUserMinAmount: "",
        });
    };

    // ---------------------------------------------------------------------------------------------------------
    async componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            });
            var self = this;
            const response = await $POST(`employeelogin?command=checkemployeelogin`);
            const arr = response.data;
            if (response.status == 200) {
                if (arr.result === "ok") {
                    self.getFinancialDocPaing();
                } else if (arr.result === "error") {
                    self.setState({ redirect: true });
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        } else {
            this.setState({ redirect: true });
        }
    }

    // -------------------------------------------------------------------------------------------------------------------
    async getFinancialDocPaing() {

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        const response2 = await $POST(`reportfinancial2?command=get_alluser`);
        const newoptions = [{ value: "0", label: "همه کاربران" }];
        for (let i = 0; i < response2.data.data.length; i++) {
            newoptions.push({
                value: response2.data.data[i].user_id,
                label:
                    response2.data.data[i].user_mobile +
                    "-" +
                    response2.data.data[i].user_name,
            });
        }

        this.setState({
            optionUser: newoptions,
            selectedUser: newoptions[0], // پیش‌فرض: همه کاربران
        });
    }

    handleSubmitFilter = async () => {
        const {
            Amount,
            selectedWalletMode,
            selectedUser,
            description,
        } = this.state;

        console.log(Amount, selectedWalletMode.value, selectedUser.value,description);

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })


                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })


                }

                self.setState({
                    Amount: "",                    // ← خالی کردن state
                    selectedWalletMode: {},        // ← خالی کردن انتخاب
                    selectedUser: {},              // ← خالی کردن انتخاب
                    description: ""                // ← خالی کردن متن
                });

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

            }
        };

        var fd = new FormData();
        fd.append("command", "change_wallet_balance");
        fd.append("Amount", Amount);
        fd.append("selectedWalletMode", selectedWalletMode.value);
        fd.append("selectedUser", selectedUser.value);
        fd.append("description", description);

        xhttp.open("POST", `${constants.BASE_URL}/Userwallet`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }



    // -------------------------------------------------------------------------------------------------------------------

    handleUser = (selectedUser) => {
        this.setState({ selectedUser: selectedUser }, () => {});
    };

    handleMarketingMode = (selectedMarketingMode) => {
        this.setState({ selectedMarketingMode: selectedMarketingMode }, () => {});
    };

    handleWalletMode = (selectedWalletMode) => {
        this.setState({ selectedWalletMode: selectedWalletMode }, () => {});
    };


    // ************************************************************************************************************************
    // ************************************************************************************************************************
    // ************************************************************************************************************************


    render() {
        const { classes } = this.props;
        const {
            sumPay,
            arrayPay,
            WalletUserMaxDate,
            WalletUserMinDate,
            user_wallet_amount,
            Amount,
            WalletUserMinAmount,
            optionUser,
            selectedUser,
            optionMarketingMode,
            selectedMarketingMode,
            optionWalletMode,
            selectedWalletMode,
            optionWalletGift,
            selectedWalletGift,
            WalletUser,
            snackMode,
            snackstr,
            showSnack,
            newFinancialDoc,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            requestinfofilter,
            rowsPerPage,
            page,
            arrCount,
            sumtaraz,
        } = this.state;
        if (redirect) {
            return <Redirect to="/" />;
        } else {
            return (
                <div
                    className={classes.paperrtl}
                    dir="ltr"
                >
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                type="currency"
                                                placeholder="حداکثر مبلغ"
                                                handleInputt={this.handleChangeAmount}
                                                value={Amount}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <label className="on">نوع عملیات</label>
                                            <Select
                                                isSearchable
                                                className="adapter-txtsize"
                                                placeholder="نوع عملیات"
                                                value={this.state.selectedWaselectedWalletModelletMode}
                                                onChange={this.handleWalletMode}
                                                options={this.state.optionWalletMode}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <label className="on">کاربر</label>
                                            <Select
                                                isSearchable
                                                className="adapter-txtsize"
                                                placeholder="کاربر"
                                                value={selectedUser}
                                                onChange={this.handleUser}
                                                options={optionUser}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                type="textarea"
                                                placeholder="توضیحات"
                                                handleInputt={this.handleChangeDescription}
                                                value={this.state.description}
                                                rows={3}
                                            />
                                        </Grid>



                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={this.handleSubmitFilter}
                                            >
                                                ثبت
                                            </Button>
                                        </Grid>
                                    </Grid>



                                </Paper>
                            </Container>
                        </Grid>

                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>
            );
        }
    }
}

export default withStyles(styles)(ChangeWalletBalance);
